import ContentHeader from "../../components/content-header/ContentHeader";
import React, { Component, useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import Select from "react-select";
import { addOEM, getOEMDetails, updateOEM } from "../../services/data-service/oem-service";
import {
  getAllStates,
  getDistrictByState,
} from "../../services/data-service/master-service";
import { getRandom3 } from "../../services/common/utils";
import { toast } from "react-toastify";
import { FcPrevious } from "react-icons/fc";
import PageLoader from "../../components/PageLoader";

const AddOEM = () => {
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const [stateOption, setStateOption] = useState(null)
  const [selectedState, setSelectedState] = useState("")
  const [districtOption, setDistrictOption] = useState(null)
  const [selectedDistrict, setSelectedDistrict] = useState("")
  const [getOemDetail, setGetOemDetail] = useState(null)
  const { id } = useParams();
  const [oemError, setOemError] = useState([])
  //  console.log('oemError', oemError)

  const onStateChanged = (stateId) => {
    setSelectedState(stateId)
    getDistrictByState(stateId)
      .then((response) => {
        let tempOption = [];
        response.data.map((item) =>
          tempOption.push({
            value: item.id,
            label: item.district,
          })
        );
        setDistrictOption(tempOption);
      })
      .catch((error) => {
        console.log(error);
      })
      .finally(()=>{
        setLoading(false)
      })
  }

  const onDistrictChanged = (districtId) => {
    setSelectedDistrict(districtId);
  }

  async function fetchData(){
    setOemError([])
    setGetOemDetail(null)
    setSelectedState('')
    setSelectedDistrict('')
    setLoading(true)     
    await getAllStates().then((response) => {
      let tempOption = [];
      response.data.map((item) =>
        tempOption.push({
          value: item.id,
          label: item.state,
        })
      );
      setStateOption(tempOption)
    })
    .catch((error) => {
      console.log(error);
    })
    .finally(()=>{
      if(!id){
        setLoading(false)
      } 
      
    })
    
    if(id){
      await getOEMDetails(id).then((response)=>{        
        if(response.data.status === 'error'){
          toast.error(response.data.message)
        }else{
          let detailOem = response?.data          
          setGetOemDetail(detailOem)
          if(detailOem?.state_id && detailOem?.district_id){
            onStateChanged(detailOem?.state_id)
            setSelectedDistrict(detailOem?.district_id)            
          }else{
            setLoading(false)
          }          
        }        
      })
    }

  }

  useEffect(() => {
    fetchData()
  }, [id])

  async function handleSubmit(event) {
    event.preventDefault();
    const data = event.target.elements;
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    const phoneRegex = /^[0-9]\d{9}$/;    
    const pinRegex = /^[0-9]\d{5}$/;

    if(!data.oemName.value.trim().length > 0){
      toast.error( "OEM Name is required")
      return;      
    } 
    else if(!data.prefix.value.trim().length > 0){
      toast.error( "Prefix is required")
      return;      
    }
    else if (!phoneRegex.test(data.contactNumber.value.trim())){
      toast.error( "Invalid mobile number. Must be 10 digits")
      return;
    }
    else if (!emailRegex.test(data.emailID.value.trim())) {
      toast.error("Invalid email address")
      return;
    }
    else if (!selectedState) {
      toast.error("Select the state")
      return;
    }
    else if (!selectedDistrict) {
      toast.error("Select the district")
      return;
    }
    else if (!data.city.value.trim().length > 0) {
      toast.error( "City is required")
      return;
    }
    else if (!pinRegex.test(data.pincode.value.trim())) {
      toast.error("Invalid pincode. Must be 6 digits")
      return;
    }
    else if (!data.address.value.trim().length > 0) {
      toast.error("Address is required")
      return;
    } 

    const payload = {
      oem_name: data.oemName.value.trim(),
      oem_mobile: data.contactNumber.value.trim(),
      oem_email: data.emailID.value.trim(),
      oem_prefix: data.prefix.value.trim(),
      oem_state: selectedState,
      oem_district: selectedDistrict,
      oem_city: data.city.value.trim(),
      oem_pincode: data.pincode.value.trim(),
      oem_address: data.address.value.trim(),
    };
    // console.log(payload);
    
    if(id){
      payload.id = parseInt(id)      
      await updateOEM(payload).then((response) => {
        console.log(response)
        if(response.data.status === 'success'){
          toast.success(response.data.message);
          // window.location.href = "/#/oem";
          navigate("/oems");
        }else if (response.data.status === 'error'){
          toast.error(response.data.message)
        }      
      })
      .catch((err)=>{
        toast.error("Some error occured")
      })
    }else{
      await addOEM(payload).then((response) => {
        if(response.data.status === 'success'){
          toast.success(response.data.message);
          // window.location.href = "/#/oem";
          navigate("/oems");
        }else if (response.data.status === 'error'){
          // console.log(response?.data?.message)
          if(Array.isArray(response?.data?.message)){
            setOemError(response?.data?.message)
          }else{
            toast.error(response.data.message)
          }          
        }      
      })
      .catch((err)=>{
        toast.error("Some error occured")
      })
    }

    
  }
    return (
      <div>
        <ContentHeader title={id ? "Edit OEM" : "Add OEM"} />
        <section className="content">
          <div className="container-fluid">
            <div className="card">
              <div className="card-header">
                <div className="card-title d-flex justify-content-between align-items-center w-100">
                  <span>
                    {id ? 'Edit OEM' : 'Add OEM'}
                  </span>
                  {                  
                    <Link to={`/oems`}>                
                      <span>
                        <FcPrevious 
                          fontSize="22px"
                        />
                      </span>
                    </Link>
                  }
                </div>
                
              </div>
              <div className="card-body">
                {
                  loading ? <PageLoader /> :
                  <section className="content">
                    <form
                        id="quickForm"
                        noValidate="novalidate"
                        onSubmit={handleSubmit}
                    >
                        <div className="container-fluid">
                        {/* Main row */}
                        <div className="row">
                            <div className="col-md-12">
                            {/* jquery validation */}
                            <div className="card card-primary">
                                {/* /.card-header */}
                                <div className="card-body">
                                {/* form start */}
                                {/* <form id="quickForm" noValidate="novalidate"> */}
                                <div className="row">
                                    {/* Left */}
                                    <div className="col-md-4">
                                    <div className="form-group">
                                        <label htmlFor="oemName">OEM Name</label>
                                        <input
                                          defaultValue={getOemDetail?.oem_name}
                                          type="text"
                                          name="text"
                                          className="form-control"
                                          id="oemName"
                                          placeholder="OEM Name"
                                        />
                                        {oemError.length > 0 && oemError.filter(item => item.field === 'oem_name').length > 0 && (
                                          <p className="text-danger">
                                            {oemError.find(item => item.field === 'oem_name')?.message}
                                          </p>
                                        )}
                                    </div>

                                    <div className="form-group">
                                        <label htmlFor="Prefix">Prefix</label>
                                        <input
                                          disabled={id ? true : false}
                                          defaultValue={getOemDetail?.prefix}
                                          type="text"
                                          name="text"
                                          className="form-control"
                                          id="prefix"
                                          placeholder="Prefix for user login"
                                        />
                                        {oemError.length > 0 && oemError.filter(item => item.field === 'oem_prefix').length > 0 && (
                                          <p className="text-danger">
                                            {oemError.find(item => item.field === 'oem_prefix')?.message}
                                          </p>
                                        )}
                                    </div>  

                                    <div className="form-group">
                                        <label htmlFor="contactNumber">
                                          Contact Number
                                        </label>
                                        <input
                                          defaultValue={getOemDetail?.oem_mobile}
                                          type="number"
                                          name="text"
                                          className="form-control"
                                          id="contactNumber"
                                          placeholder="Contact No"
                                        />
                                        {oemError.length > 0 && oemError.filter(item => item.field === 'oem_mobile').length > 0 && (
                                          <p className="text-danger">
                                            {oemError.find(item => item.field === 'oem_mobile')?.message}
                                          </p>
                                        )}
                                    </div>
                                    <div className="form-group">
                                        <label htmlFor="emailID">Email Address</label>
                                        <input
                                          defaultValue={getOemDetail?.oem_email}
                                          type="email"
                                          name="text"
                                          className="form-control"
                                          id="emailID"
                                          placeholder="Email Id"
                                        />
                                        {oemError.length > 0 && oemError.filter(item => item.field === 'oem_email').length > 0 && (
                                          <p className="text-danger">
                                            {oemError.find(item => item.field === 'oem_email')?.message}
                                          </p>
                                        )}
                                    </div>
                                    {/* <div className="form-group">
                                        <label htmlFor="gst">GST</label>
                                        <input
                                        type="text"
                                        name="text"
                                        className="form-control"
                                        id="gst"
                                        placeholder="GST No"
                                        />
                                    </div> */}
                                    </div>
                                    {/* Middle */}
                                    <div className="col-md-4">
                                    <div className="form-group">
                                        <label htmlFor="Payment Type">Payment Type</label>
                                        <Select
                                          isDisabled={id ? true : false}
                                          className="select2bs4"
                                          style={{ width: "100%" }}
                                          options={[
                                              { label: "Prepaid", value: 1},
                                              { label: "Postpaid", value: 2}
                                          ]
                                          }
                                        ></Select>
                                    </div>                         
                                    <div className="form-group">
                                        <label htmlFor="emsState">State</label>
                                        {stateOption && (
                                        <Select
                                            className="select2bs4"
                                            defaultValue={                                        
                                              stateOption && stateOption.find((item)=>item.value === getOemDetail?.state_id)                                        
                                            }
                                            style={{ width: "100%" }}
                                            options={stateOption}
                                            onChange={(e) => onStateChanged(e.value)}
                                        ></Select>
                                        )}
                                        {oemError.length > 0 && oemError.filter(item => item.field === 'oem_state').length > 0 && (
                                          <p className="text-danger">
                                            {oemError.find(item => item.field === 'oem_state')?.message}
                                          </p>
                                        )}
                                    </div>
                                    <div className="form-group">
                                        <label htmlFor="district">District</label>
                                        {districtOption ? (<Select
                                        className="select2bs4"
                                        style={{ width: "100%" }}
                                        options={districtOption}
                                        defaultValue={                                        
                                          districtOption && districtOption.find((item)=>item.value === getOemDetail?.district_id
                                        )}
                                        onChange={(e) =>
                                            onDistrictChanged(e.value)
                                        }
                                        ></Select>) : (
                                        <input
                                        type="text"
                                        name="text"
                                        className="form-control"
                                        disabled
                                        />
                                        ) }
                                        {oemError.length > 0 && oemError.filter(item => item.field === 'oem_district').length > 0 && (
                                          <p className="text-danger">
                                            {oemError.find(item => item.field === 'oem_district')?.message}
                                          </p>
                                        )}
                                    </div>
                                    </div>
                                    {/* Right */}
                                    <div className="col-md-4">
                                    <div className="form-group">
                                        <label htmlFor="city">City</label>
                                        <input
                                          defaultValue={getOemDetail?.city}
                                          type="text"
                                          name="text"
                                          className="form-control"
                                          id="city"
                                          placeholder="city"
                                        />
                                        {oemError.length > 0 && oemError.filter(item => item.field === 'oem_city').length > 0 && (
                                          <p className="text-danger">
                                            {oemError.find(item => item.field === 'oem_city')?.message}
                                          </p>
                                        )}
                                    </div>

                                    <div className="form-group">
                                        <label htmlFor="pincode">PinCode</label>
                                        <input
                                          defaultValue={getOemDetail?.oem_pincode}
                                          type="number"
                                          name="text"
                                          className="form-control"
                                          id="pincode"
                                          placeholder="Pincode"
                                        />
                                        {oemError.length > 0 && oemError.filter(item => item.field === 'oem_pincode').length > 0 && (
                                          <p className="text-danger">
                                            {oemError.find(item => item.field === 'oem_pincode')?.message}
                                          </p>
                                        )}
                                    </div>
                                    <div className="form-group">
                                        <label htmlFor="address">Address</label>
                                        <textarea
                                          defaultValue={getOemDetail?.oem_address}
                                          className="form-control"
                                          id="address"
                                          rows="4"
                                        />
                                        {oemError.length > 0 && oemError.filter(item => item.field === 'oem_address').length > 0 && (
                                          <p className="text-danger">
                                            {oemError.find(item => item.field === 'oem_address')?.message}
                                          </p>
                                        )}
                                    </div>
                                    </div>
                                </div>
                                {/* </form> */}
                                </div>
                                {/* /.card-body */}
                                <div className="card-footer">
                                <button
                                    type="submit"
                                    className="btn btn-primary float-right"
                                >
                                    Submit
                                </button>
                                </div>
                            </div>
                            {/* /.card */}
                            </div>
                        </div>
                        {/* /.row (main row) */}
                        </div>
                        {/* /.container-fluid */}
                    </form>
                  </section> 
                }                               
              </div>
              {/* <div className="card-footer">Footer</div> */}
            </div>
          </div>
        </section>
      </div>
    );
  };
  
  export default AddOEM;